
export class PCodeConfig
{
	static azureAd: PCodeConfigAzureAd =
		{
			tenantId: 'b4b8364a-25c9-4632-8783-6856868d1f00',
			clientId: '02400c91-41c5-4192-b925-f47c87f21ca4'
		}

	static vapid: PCodeConfigVapid =
		{
			publicKey: 'BHizkSp85qDkNe3OA_maTi-W3tO5aEPkwaCGDdMrKFyUFNUWM5cBo3ccF3aaQxo_PMheg1b71wixiqWe3YqYlkg'
		}
}

interface PCodeConfigAzureAd
{
	tenantId: string;
	clientId: string;
}
interface PCodeConfigVapid
{
	publicKey: string;
}